module.exports = __webpack_public_path__ + "media/images/svg/dashboard-f2f0efe78de372f0de2d2e004fce738f.svg";